import { connect } from 'react-redux';
import { StripePage } from './StripePage';
import { getListActions, getListState } from '../../../utilites/helpers/crudListHelper';
import { stripeActions } from '../../../actions/shop/stripe';
import LoadingContainer from '../../LoadingContainer';

export default connect(
  ({ shop_stripe }) => (Object.assign(
    {
      loadingItem: shop_stripe.loadingItem || false,
      disabled: shop_stripe.loadingItem || shop_stripe.error !== null,
      childrenComponent: StripePage,
      childrenProps: {
        title: 'Shop payments'
      }
    },
    getListState(shop_stripe), {
      title: 'Shop payments',
      connect: stripeActions.connect
    }
  )),
  (dispatch) => Object.assign(getListActions(stripeActions, dispatch), {
    init: () => dispatch(stripeActions.fetch()),
  })
)(LoadingContainer);



// export default connect(
//   ({ competition: { loadingItem } }) => ({
//     loading: loadingItem,
//     childrenComponent: CompetitionsEditForm,
//     childrenProps: {
//       title: 'Edit Competition',
//       isNew: false
//     }
//   }),
//   dispatch => ({
//     init: ({ params: { id }}) => dispatch(CRUDAction.fetch(id))
//   })
// )(LoadingContainer);


// WEBPACK FOOTER //
// ./src/components/Shop/StripePage/index.js